import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { GapBox } from 'components/Box'
import { BoxForm, CodeField, NumberField } from 'components/Form'
import { SectionHeader } from 'components/Header'
import Paper from 'components/Paper'
import { useAbility } from 'providers/casl'
import { KNOWLEDGE_BASE_URL } from '../constants'
import { Schema } from '../schema'

export const AdvancedPrebidSection = (): JSX.Element => {
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'prebid.defaults.advancedPrebidSettings',
  })
  const { t: tC } = useTranslation('common')
  const { control } = useFormContext<Schema>()

  const ability = useAbility()
  const cannotUpdate: boolean = ability.cannot('update', 'GlobalSetupFeature-prebidDefaults')

  return (
    <Paper>
      <SectionHeader
        subtitle={t('subtitle')}
        title={t('title')}
      />

      <GapBox />

      <BoxForm>
        <NumberField
          control={control}
          disabled={cannotUpdate}
          label={t('auctionDelay.label')}
          name='auctionDelay'
          tooltip={{
            content: t('auctionDelay.tooltip'),
            link: {
              title: tC('learnMore'),
              url: KNOWLEDGE_BASE_URL.TIMEOUTS,
            },
          }}
        />

        <CodeField
          control={control}
          disabled={cannotUpdate}
          language='javascript'
          name='allowActivitiesData'
          options={{ renderValidationDecorations: 'off' }}
          title={t('allowActivitiesData.label')}
          tooltip={{
            content: t('allowActivitiesData.tooltip'),
            link: {
              title: tC('learnMore'),
              url: KNOWLEDGE_BASE_URL.ALLOW_ACTIVITIES,
            },
          }}
        />
      </BoxForm>
    </Paper>
  )
}
